// Three-dot sidebar menu button. Opens a shared dropdown via root state.
// The dropdown itself lives on the page level (ChatSidebarDropdown) to
// avoid parent opacity/overflow clipping issues.

export const SidebarItemMore = {
  tag: 'button',
  type: 'button',
  'aria-label': 'More options',
  text: '···',
  fontSize: 'A',
  fontWeight: '700',
  letterSpacing: '.1em',
  padding: '0 V',
  background: 'transparent',
  borderWidth: '0',
  color: 'caption',
  cursor: 'pointer',
  transition: 'opacity 120ms ease',
  flexShrink: '0',
  ':hover': { color: 'title' },

  onCreate: (el) => {
    if (!el.node) return
    el.node.style.opacity = '0'
    const row = el.node.closest('[data-sidebar-row]') || el.node.closest('[data-cid]')
    if (!row) return
    el._row = row
    el._onEnter = () => { if (el.node) el.node.style.opacity = '1' }
    el._onLeave = () => {
      if (!el.node) return
      // Don't hide if dropdown is open for this row
      const root = el.state?.root
      if (root?.sidebarDropdown?.open) return
      el.node.style.opacity = '0'
    }
    row.addEventListener('mouseenter', el._onEnter)
    row.addEventListener('mouseleave', el._onLeave)
  },

  onRemove: (el) => {
    if (el._row) {
      el._row.removeEventListener('mouseenter', el._onEnter)
      el._row.removeEventListener('mouseleave', el._onLeave)
    }
  },

  onClick: (e, el, s) => {
    e.stopPropagation()
    e.stopImmediatePropagation()
    e.preventDefault()
    const root = s?.root
    if (!root) return

    // Get the channel id from the row
    const row = el.node.closest('[data-cid]')
    const cid = row?.getAttribute('data-cid')
    if (!cid) return

    // Determine items from channel kind
    const ch = (root.channels || []).find(c => c.id === cid)
    const kind = ch?.kind || 'channel'
    let items
    if (kind === 'channel') {
      items = [
        { label: 'Invite', action: 'invite-channel' },
        { label: 'Rename', action: 'rename-channel' },
        { label: 'Settings', action: 'channel-settings' },
        { label: 'Pin to top', action: 'pin-to-top' }
      ]
    } else if (kind === 'group_dm') {
      items = [
        { label: 'Create channel', action: 'convert-to-channel' },
        { label: 'Rename', action: 'rename-channel' },
        { label: 'Pin to top', action: 'pin-to-top' },
        { label: 'Hide', action: 'hide-dm' },
        { label: 'Leave', action: 'leave-channel', color: 'red' }
      ]
    } else {
      items = [
        { label: 'Hide', action: 'hide-dm' },
        { label: 'Start group chat', action: 'start-group-chat' },
        { label: 'Pin to top', action: 'pin-to-top' }
      ]
    }

    // Get position
    const rect = el.node.getBoundingClientRect()

    // Toggle — close if already open for this row, open otherwise
    const dd = root.sidebarDropdown
    if (dd?.open && dd?.channelId === cid) {
      root.update({ sidebarDropdown: { open: false } })
    } else {
      root.update({
        sidebarDropdown: {
          open: true,
          channelId: cid,
          items,
          top: rect.bottom + 2,
          left: rect.right,
          btnTop: rect.top
        }
      })
    }
  },

  // Hidden dropdown template — items rendered by the shared ChatSidebarDropdown
  Dropdown: { display: 'none' }
}

export const SidebarItemMenuItem = {
  tag: 'button',
  type: 'button',
  padding: 'Z A',
  round: 'V',
  background: 'transparent',
  borderWidth: '0',
  cursor: 'pointer',
  fontSize: 'Z2',
  fontWeight: '500',
  textAlign: 'left',
  whiteSpace: 'nowrap',
  color: (el, s) => s.color || 'title',
  ':hover': { background: 'overlay' },
  text: (el, s) => s.label || ''
}
